import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "./AuthContext";
import { Logo } from "../components/site/Navbar";
import useSeo from "../lib/useSeo";

export default function AdminLogin() {
  useSeo({ title: "Admin Login | Wandervibe Journeys", description: "", path: "/admin/login", noindex: true });
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="grid min-h-screen place-items-center bg-[#F8FAFC] px-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-slate-200 bg-white p-8 shadow-xl" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-8 flex items-center gap-2 text-2xl"><Lock className="h-5 w-5 text-[#FD691B]" />Admin sign in</h1>
        <div className="mt-6 space-y-4">
          <div><label className="label" htmlFor="admin-email">Email</label><input id="admin-email" type="email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" /></div>
          <div><label className="label" htmlFor="admin-password">Password</label><input id="admin-password" type="password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" /></div>
          {error && <p className="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
          <button disabled={loading} className="btn-brand w-full" data-testid="admin-login-submit-btn">{loading && <Loader2 className="h-4 w-4 animate-spin" />}Sign in</button>
        </div>
      </form>
    </div>
  );
}
